export default function Subtitle(props) {
  return (
    <div className={`text-2xl md:text-3xl font-bold text-left text-pink-800 ${props.className}`}>
      {props.children}
    </div>
  );
}